import React from 'react';
import { Card, CardHeader } from '../../components/Bootstrap';
import { BarList, NoDataAvailable } from '../../components';

export class TopSellingDrinks extends React.Component<any, any> {
  render() {
    const total = this.props.data.reduce((accum, val) => {
      return accum + Number(val.total);
    }, 0);

    const drinks = this.props.data.map((drink) => {
      return {
        name: drink.name,
        progressValue: Number(drink.total) / total,
        value: `$${drink.total}`,
      };
    });

    let content = <BarList data={drinks} />;

    if (!drinks || !drinks.length) {
      content = <NoDataAvailable className='text-md-center no-data-available-drinks' />;
    }

    return (
      <Card className='top-selling-drinks border-left-0 border-right-0'>
        <CardHeader>Top Selling Items</CardHeader>
        {content}
      </Card>
    );
  }
}
